<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
			<v-row>
				<v-col cols="12" md="6">
					<v-select v-model="selectedUserLoan" :disabled="isAdmin" clearable required single-line return-object :items="userLoans" label="وام*" item-text="title" item-value="id" :error-messages="errorMessages" :rules="[() => !!selectedUserLoan || 'وام را انتخاب کنید']" />
				</v-col>
				<v-col cols="12" md="6">
					<v-select v-model="localData.loanPayment" :disabled="isAdmin" clearable required single-line return-object :items="loanPayments" label="شماره قسط*" item-text="title" item-value="id" :error-messages="errorMessages" :rules="[() => !!localData.loanPayment || 'شماره قسط را انتخاب کنید']" />
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="6">
					<div>
						<div>تاریخ واریز:*</div>
						<date-picker ref="paymentDate" v-model="localData.paymentDate" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" :disabled="isAdmin" :rules="[() => !!localData.paymentDate || 'تاریخ واریز را به صورت صحیح وارد کنید']" />
					</div>
					<div>
						<v-text-money ref="amount" v-model="localData.amount" :label="'مبلغ واریزی* (تومان)'" :error-messages="errorMessages" :disabled="isAdmin" :rules="[() => localData.amount > 0 || 'مبلغ را به صورت صحیح وارد کنید']" required />
					</div>
					<div>
						<v-select v-model="localData.paymentMethod" clearable required :items="paymentMethods" label="نحوه پرداخت*" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" :rules="[() => !!localData.paymentMethod || 'نحوه پرداخت را انتخاب کنید']" />
					</div>
					<div>
						<v-text-field :disabled="isAdmin" v-if="localData.paymentMethod != 1" ref="trackNumber" v-model="localData.trackNumber" label="شماره فیش/پیگیری" :error-messages="errorMessages" />
					</div>
				</v-col>
				<v-col cols="12" md="6">
					<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
						<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
						<span>فایل پیوست</span>
					</div>
					<ImageUploader ref="imageUploader" v-model="localData.base64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.base64)" @delete="() => localData.fileName = ''" />
				</v-col>
			</v-row>
			<!-- <v-row>
				<v-col cols="12" md="6">
				</v-col>
				<v-col cols="12" md="6">
				</v-col>
			</v-row> -->
			<v-row>
				<v-col cols="12">
					<small v-if="payHint">{{ payHint }}</small>
					<v-textarea v-model="localData.memberDescription" :disabled="isAdmin" outlined :error-messages="errorMessages" label="توضیحات" hint="حداکثر 1000 کاراکتر" />
				</v-col>
			</v-row>
			<hr />
			<div v-if="isAdmin">
				<v-row>
					<v-col cols="12" md="6">
						تاریخ ثبت درخواست: {{ (localData.requestDate_Persian || {}).date }} {{ (localData.requestDate_Persian ||
							{}).time }}
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<v-textarea v-model="localData.adminDescription" outlined :error-messages="errorMessages" label="توضیحات ادمین" hint="حداکثر 1000 کاراکتر" />
					</v-col>
				</v-row>
				<v-row v-if="localData.status > 0">
					<v-col cols="12" md="6">
						بررسی کننده: <br>{{ (localData.adminAcceptor || {}).fullName }}
					</v-col>
					<v-col cols="12" md="6">
						تاریخ بررسی: <br>{{ (localData.adminAcceptDate_Persian || {}).date }} {{ (localData.adminAcceptDate_Persian ||
							{}).time }}
					</v-col>
				</v-row>
			</div>
			<div v-else-if="localData.id != '00000000-0000-0000-0000-000000000000'">
				<v-row>
					<v-col cols="12" md="6">
						تاریخ ثبت درخواست: {{ (localData.requestDate_Persian || {}).date }} {{ (localData.requestDate_Persian ||
							{}).time }}
					</v-col>
					<v-col cols="12" md="6">
						وضعیت: {{ localData.str_Status }}
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12">
						<div class="black--text mt-2">
							توضیحات مدیر سایت:
						</div>
						{{ (localData.adminDescription || 'توضیحاتی ثبت نشده است.') }}
					</v-col>
				</v-row>
			</div>
			<v-card-actions>
				<v-spacer v-if="isAdmin" />
				<v-btn v-if="isAdmin" color="success" dark @click="acceptRequest()">
					تایید
				</v-btn>
				<v-btn v-if="isAdmin" color="success" dark @click="acceptRequest(true)">
					تایید و ثبت در پرداختی قسط
				</v-btn>
				<v-btn v-if="isAdmin" color="red" dark @click="rejectRequest()">
					عدم تایید
				</v-btn>
				<v-spacer v-if="!isAdmin" />
				<v-btn @click="$emit('callbck', false)" v-if="!isAdmin">
					بستن
				</v-btn>
				<v-btn color="blue" dark type="submit" :loading="loading" :disabled="localData.status > 0 && !isAdmin" v-if="!isAdmin">
					ذخیره
				</v-btn>
			</v-card-actions>
		</v-form>
		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import { get } from 'vuex-pathify'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import { obj2FormData } from '@/util/helpers.js'
	import ImageUploader from '@/components/uploader/ImageUploader'

	export default {
		name: 'ModifyPaymentRequestView',
		props: {
			isAdmin: { type: Boolean },
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-picker': VuePersianDatetimePicker,
			ImageUploader,
		},
		data() {
			return {
				loading: false,
				errorMessages: '',
				selectedUserLoan: null,
				localData: {},
				userLoans: [],
				overlayImgSrc: '',
				overlay: false,
				statuses: [{
					id: 0,
					title: 'در انتظار بررسی'
				}, {
					id: 1,
					title: 'تایید شده'
				}, {
					id: 2,
					title: 'عدم تایید'
				}],
				paymentMethods: [{
					id: 1,
					title: 'نقدی'
				}, {
					id: 2,
					title: 'بانک (فیش،کارت به کارت)'
				}, {
					id: 4,
					title: 'آنلاین'
				}],
				loanPayments: []
			}
		},
		watch: {
			selectedUserLoan: {
				deep: true,
				handler(val) {
					this.loanPayments = val?.loanPayments || []
				}
			}
		},
		computed: {
			payHint() {
				switch (this.localData.paymentMethod?.id) {
					case 1:
					case 4:
						return ''
					case 2:
						return 'در روش بانکی می توانید شماره کارت و نام صاحب حساب و یا دیگر اطلاعات لازم جهت پیگیری سریعتر در بخش توضیحات ذکر کنید.'
					default:
						return ''
				}
			},
			...get('appSettings', [
				'settings',
			])
		},
		mounted() {
			this.prepareData()
		},
		methods: {
			async submit(affect) {
				if (this.localData.status > 0 && !this.isAdmin) {
					toast.error('این درخواست به دلیل اینکه توسط مدیر تغییر وضعیت داده شده است قابل ویرایش نمی باشد.')
					return
				}
				if (!this.$refs.form.validate()) { return }
				this.localData.affectOnMainPayment = !!affect
				let clonedData = {}
				Object.assign(clonedData, this.localData)
				clonedData.paymentMethod = this.localData.paymentMethod.id
				if (this.isAdmin && this.settings.thanksPaymentSmsPattern) {
					var confirmSms = await this.$refs.confirm.open(
						'توجه',
						'آیا مایل به ارسال پیامک ثبت قسط به مشتری هستید؟',
					)
				}
				clonedData.sendSms = !!confirmSms
				delete clonedData.base64
				clonedData.loanPayment = { id: clonedData.loanPayment.id }
				const formData = obj2FormData(clonedData)
				var fileUploader = this.$refs['imageUploader'] ? this.$refs['imageUploader'] : null
				if (fileUploader && fileUploader.hasFile()) {
					formData.append('file', fileUploader.getFile())
				}
				this.loading = true
				api.post(`${this.isAdmin ? 'admin' : 'member'}/userLoanPaymentRequest/` + (this.localData.id === emptyId ? 'create' : 'edit'), formData, { contentType: 'multipart/form-data' })
					.then(
						response => {
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.$emit('callbck', true)
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading - false
					})
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: emptyId }
				}
				if (!this.data.id) {
					this.data.id = emptyId
				}
				api.get(`${this.isAdmin ? 'admin' : 'member'}/userLoanPaymentRequest/get/` + this.data.id, null)
					.then(response => {
						this.localData = response
						if (this.data.id === emptyId)
							Object.assign(this.localData, this.data)

						if (!this.localData.paymentMethod)
							delete this.localData.paymentMethod
						else
							this.localData.paymentMethod = this.paymentMethods.find(x => x.id == response.paymentMethod)
					})
					.catch(err => {
						toast.error(err.message)
					})
				this.loadUserLoans()
			},
			loadUserLoans() {
				if (this.isAdmin || (this.data?.loanPayment && this.data?.id === emptyId)) {
					this.userLoans = [{
						id: this.data.loanPayment.userLoanModel.id,
						title: `${this.data.loanPayment.userLoanModel.loanModel.title} (شماره پرونده: ${this.data.loanPayment.userLoanModel.code}) (مبلغ: ${this.data.loanPayment.userLoanModel.amount.toString().toPriceFormat()})`,
						loanPayments: [{
							id: this.data.loanPayment.id,
							title: `قسط شماره ${this.data.loanPayment.installmentNumber} (سررسید:${this.data.loanPayment.targetMonth_Persian.date}`
						}]
					}]
					if (this.data.loanPayment?.userLoanModel) {
						this.selectedUserLoan = this.userLoans.find(x => x.id == this.data.loanPayment.userLoanModel.id)
					}
				} else {
					api.get('member/UserLoanPaymentRequest/LoansList', null)
						.then(
							response => {
								this.userLoans = response.map(x => {
									return {
										id: x.id,
										title: `${x.loanModel.title} (کد: ${x.code}) (مبلغ: ${x.amount.toString().toPriceFormat()})`,
										loanPayments: x.loanPayments.map(p => {
											return {
												id: p.id,
												title: `قسط شماره ${p.installmentNumber} (سررسید:${p.targetMonth_Persian.date})`
											}
										})
									}

								})
								if (this.localData.loanPayment?.userLoanModel) {
									this.selectedUserLoan = this.userLoans.find(x => x.id == this.localData.loanPayment.userLoanModel.id)
								}
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			acceptRequest(affect) {
				this.localData.status = 1
				this.submit(affect)
			},
			rejectRequest() {
				this.localData.status = 2
				this.submit()
			},
			viewImage(img) {
				this.overlay = true
				this.overlayImgSrc = img
			},
		},
	}
</script>
<style></style>
